import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { RequestGetHistoryDto, RequestGetPaymentHistoryDto } from '../gd-integrated/dto/loan.dto';

@Injectable()
export class LoanProvider {

  private _service: string = 'loan';
  private _model: string = 'sf6s/loan';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public add(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'add';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public updatePost(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'updatePost';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public delete(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'delete';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public edit(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'edit';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public requestInbox(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'requestInbox';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public loanHistory(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'loanHistory';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public requestDetail(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'requestDetail';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public loanType(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'loanType';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public compParam(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'compParam';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public calculateLoanAmount(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'calculateLoanAmountPost';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public loanReqApproval(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'loanReqApproval';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public history(limit: string | number, page: string | number, formData?: RequestGetHistoryDto): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'emploanHistory';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request<RequestGetHistoryDto>(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public payment(limit: string | number, page: string | number, formData?: RequestGetPaymentHistoryDto): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'payment';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;
    
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request<RequestGetPaymentHistoryDto>(_method, _url, _params, _urlParams, _body, _contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/loan/loan-provider.ts